export default __webpack_public_path__ + "static/media/wordpress.d04af36c.png";